/**
 * Represents a location in a GraphQL query where an error occurred.
 */
export interface GraphQLErrorLocation {
  line: number;
  column: number;
}

/**
 * Standard GraphQL error shape.
 */
export interface GraphQLError {
  message: string;
  locations?: GraphQLErrorLocation[];
  path?: (string | number)[];
  extensions?: Record<string, unknown>;
  [key: string]: unknown;
}

/**
 * Custom error class for AniList API errors.
 */
export class AniListError extends Error {
  /** HTTP status code returned by the API */
  public readonly status: number;
  /** Raw error body from the API response */
  public readonly errors: GraphQLError[];

  constructor(message: string, status: number, errors: GraphQLError[] | unknown[] = []) {
    super(message);
    this.name = "AniListError";
    this.status = status;
    // We cast to GraphQLError[] since we assume the API conforms to the GraphQL spec
    // or we wrap raw network errors in a somewhat compatible shape.
    this.errors = errors as GraphQLError[];
    Object.setPrototypeOf(this, AniListError.prototype);
    type ErrorWithCaptureStackTrace = typeof Error & {
      captureStackTrace(target: object, fn: object): void;
    };
    if ("captureStackTrace" in Error) {
      (Error as ErrorWithCaptureStackTrace).captureStackTrace(this, AniListError);
    }
  }
}
